import { PropTypes } from "prop-types";

import RatingBlock from "./RatingBlock";
import studentDisplayName from "../../utils/studentDisplayName";
import T from "../translations/Translations";

import { getScrubbedRating } from "../../utils/teacher/InputRatingUtils";
/**
 * @description A component that will display the SLE ratings for a student
 * @name DisplaySleRatings
 * @param {string} gradingProfileSleComment
 * @param {[]} sleRatings
 * @param {string} studentName
 * @param {string} studentSleComment
 * @return {JSX.Element}
 */
const DisplaySleRatings = ({ gradingProfileSleComment, sleRatings, studentName, studentSleComment }) => {
    const sleTitle = T({ key: "Sle_Title" });
    const sleComment = T({ key: "Sle_Comment" });
    const sleCommentToAll = T({ key: "Sle_Comment_To_All" });
    const sleNoRatings = T({ key: "Sle_No_Ratings" });
    const sleNoComment = T({ key: "Sle_No_Comment" });

    if (gradingProfileSleComment || studentSleComment || sleRatings?.length > 0) {
        return (
            <div className="semester-container">
                <div className="semester-title">{sleTitle}</div>
                <div className="sle-ratings-container">
                    <div className="left-side">
                        {sleRatings &&
                            sleRatings?.length > 0 &&
                            sleRatings.map((sleRating) => {
                                const { sleChildRatings } = sleRating;
                                return (
                                    <div key={sleRating.sleId}>
                                        <div className="sle-rating-row">
                                            <div className="sle-expectation">{sleRating.expectation}</div>
                                            <div className="sle-rating">
                                                <RatingBlock rating={getScrubbedRating(sleRating.rating)} />
                                            </div>
                                        </div>
                                        {sleChildRatings?.map((sleChildRating) => {
                                            return (
                                                <div className="sle-rating-row-child" key={sleChildRating.sleChildId}>
                                                    <div className="sle-expectation">{sleChildRating.expectation}</div>
                                                    <div className="sle-rating">
                                                        <RatingBlock
                                                            rating={getScrubbedRating(sleChildRating.rating)}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                        {(!sleRatings || sleRatings?.length < 1) && <i>{sleNoRatings}</i>}
                    </div>
                    <div className="right-side">
                        <div className="sle-message-container">
                            <div className="sle-title">{sleCommentToAll}</div>
                            {gradingProfileSleComment || <i>{sleNoComment}</i>}
                        </div>
                        <div className="sle-message-container">
                            <div className="sle-title">
                                {studentDisplayName(studentName)}&apos;s {sleComment}
                            </div>
                            {studentSleComment || <i>{sleNoComment}</i>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

DisplaySleRatings.propTypes = {
    gradingProfileSleComment: PropTypes.string,
    sleRatings: PropTypes.instanceOf(Array),
    studentName: PropTypes.string,
    studentSleComment: PropTypes.string
};

DisplaySleRatings.defaultProps = {
    gradingProfileSleComment: null,
    sleRatings: [],
    studentName: null,
    studentSleComment: null
};

export default DisplaySleRatings;
